module.exports = "<div class=triangle></div><div class=\"ns-popover-tooltip view_stations\"><p><b>You can travel from</b></p><ul><li ng-repeat=\"station in params.selectedReturnTicketDetails.FromStations\">{{station}}</li></ul><p><b>You can travel to</b></p><ul><li ng-repeat=\"stationTo in params.selectedReturnTicketDetails.ToStations\">{{stationTo}}</li></ul></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/base/templates/ukrail/return_stations.tmpl.html
// module id = 3714
// module chunks = 0